import { apiBaseAssets, apiBaseUrl } from "../config/api";
import { useEffect, useState, useContext } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useParams } from "react-router";
import axios from "axios";
import { Navigation } from "./navigation";
import { AuthContext } from "../context/auth-context";
import "../App.css";
import lc from "../utils/language";
export const Project = ({ data }) => {
  const projectId = useParams().id;
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [project, setProject] = useState(false);
  const authContext = useContext(AuthContext);
  const isRtl = authContext.currentLanguage === "AR" ? true : false;
  const getProject = async () => {
    await axios
      .get(apiBaseUrl + "/project/" + projectId)
      .then((res) => {
        console.log("the project is ", res.data.project);
        setProject(res.data.project);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorMessage("Email Password not match!!");
      });
  };
  useEffect(() => {
    getProject();
  }, []);

  return (
    <>
      <Navigation home={false} isRtl={isRtl} />

      {project && (
        <div>
          <video
            width={window.innerWidth}
            height={window.innerHeight}
            autoPlay={true}
            controls={true}
            loop={true}
            style={{
              width: "100vw",
              height: "100vh",
              backgroundColor: "#000",
            }}
          >
            <source src={apiBaseAssets + project.video} type="video/mp4" />
          </video>

          <div style={{ padding: "2rem" }}>
            <p>{project[lc("subTitle", isRtl)]}</p>
          </div>
        </div>
      )}
      {/* </div>
      </header> */}
      <div id="footer" style={{ backgroundColor: "#000" }}>
        <div className="container text-center">
          <p>
            &copy; 2021 All Rights Reserved To PROCAST. Powerde By{" "}
            <a href="https://www.perla-tech.com" rel="nofollow">
              Perla Tech
            </a>
          </p>
        </div>
      </div>
    </>
  );
};
